export interface RoleExplanationRow {
    role: string
    description: string
}

export interface RoleExplanationTableConfig {
    sectionType?: string
    enableSearch?: string
    searchPlaceholder?: string
    tableConfig?: string
    caseViews?: string
    enableTable?: string
    productCategory?: string
    enableButton?: string
    buttonType?: 'action' | 'dropdown'
    buttonLabel?: string
    buttonUrl?: string
    errorMessage?: string
    actions?: string
    enableMultiSelectUsers?: string
    selectedUsersLabel?: string
    notifySelectedUsersLabel?: string
    deleteSelectedUsersLabel?: string
    enableGaShieldToggle?: string
    showGaShieldUsersLabel?: string
}

export interface RoleExplanationConfig {
    tooltipTitle?: string
    roleColumnLabel?: string
    descriptionColumnLabel?: string
    roles?: RoleExplanationRow[]
    table?: RoleExplanationTableConfig
}

export interface UserManagementRoleExplanationProps {
    overlayTitle?: string
    'overlay-title'?: string
    configJson?: string
    'config-json'?: string
}

function decodeHtmlEntities(str: string): string {
    const textarea = document.createElement('textarea')
    textarea.innerHTML = str
    return textarea.value
}

export function parseRoleExplanationConfig(raw: string): RoleExplanationConfig {
    if (!raw) return {}
    try {
        return (JSON.parse(decodeHtmlEntities(raw)) as RoleExplanationConfig) ?? {}
    } catch {
        return {}
    }
}
